import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, FIREARM_STORAGE_LOCATION_METADATA, FIREARM_STORAGE_LOCATION_PLI_TYPE, FIREARM_STORAGE_LOCATION_TYPE, FirearmStorageLocation, FirearmStorageLocationPLI } from 'assets-model';
import { FirearmStorageLocationPLIDataSource, FirearmStorageLocationPLIService, FirearmStorageLocationService } from 'assets-service';


@Directive()
export abstract class FirearmStorageLocationPLISearchComponentBase extends CrudListComponent<FirearmStorageLocationPLI, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'firearmStorageLocationPLIId', 'firearmStorageLocation.firearmStorageLocationId', 'comments', 'createdBy', 'createdDate', 'documentUploadedBy', 'hasDocuments', 'lockVersion', 'updatedBy', 'updatedDate', 'validFromDate', 'validToDate', 'actions'];

  public searchForm: FormGroup;

  firearmStorageLocationPLIIdFilter: number;
  @ViewChild('firearmStorageLocationPLIIdFilterInput') firearmStorageLocationPLIIdFilterInput: ElementRef;

  firearmStorageLocationFilter: FirearmStorageLocation;
  firearmStorageLocationSelectionList: FirearmStorageLocation[];
  @ViewChild('firearmStorageLocationFilterInput') firearmStorageLocationFilterInput: MatSelect;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  documentUploadedByFilter: string;
  @ViewChild('documentUploadedByFilterInput') documentUploadedByFilterInput: ElementRef;

  hasDocumentsFilter: boolean;
  @ViewChild('hasDocumentsFilterInput') hasDocumentsFilterInput: MatSelect;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;

  validFromDateFilter: Date;
  @ViewChild('validFromDateFilterInput') validFromDateFilterInput: ElementRef;
  validFromDateLessThanFilter: Date;
  @ViewChild('validFromDateLessThanFilterInput') validFromDateLessThanFilterInput: ElementRef;
  validFromDateLessThanOrEqualToFilter: Date;
  @ViewChild('validFromDateLessThanOrEqualToFilterInput') validFromDateLessThanOrEqualToFilterInput: ElementRef;
  validFromDateGreaterThanFilter: Date;
  @ViewChild('validFromDateGreaterThanFilterInput') validFromDateGreaterThanFilterInput: ElementRef;
  validFromDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('validFromDateGreaterThanOrEqualToFilterInput') validFromDateGreaterThanOrEqualToFilterInput: ElementRef;

  validToDateFilter: Date;
  @ViewChild('validToDateFilterInput') validToDateFilterInput: ElementRef;
  validToDateLessThanFilter: Date;
  @ViewChild('validToDateLessThanFilterInput') validToDateLessThanFilterInput: ElementRef;
  validToDateLessThanOrEqualToFilter: Date;
  @ViewChild('validToDateLessThanOrEqualToFilterInput') validToDateLessThanOrEqualToFilterInput: ElementRef;
  validToDateGreaterThanFilter: Date;
  @ViewChild('validToDateGreaterThanFilterInput') validToDateGreaterThanFilterInput: ElementRef;
  validToDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('validToDateGreaterThanOrEqualToFilterInput') validToDateGreaterThanOrEqualToFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmStorageLocationPLIService: FirearmStorageLocationPLIService,
    protected firearmStorageLocationService: FirearmStorageLocationService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(FIREARM_STORAGE_LOCATION_PLI_TYPE, route, router, userStorage, dialog, firearmStorageLocationPLIService, injector);

    this.searchForm = this.fb.group({
      firearmStorageLocationPLIId: [null],
      firearmStorageLocation: [null],
      comments: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      documentUploadedBy: [null],
      hasDocuments: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null],
      validFromDateLessThan: [null],
      validFromDateLessThanOrEqualTo: [null],
      validFromDateGreaterThan: [null],
      validFromDateGreaterThanOrEqualTo: [null],
      validFromDate: [null],
      validToDateLessThan: [null],
      validToDateLessThanOrEqualTo: [null],
      validToDateGreaterThan: [null],
      validToDateGreaterThanOrEqualTo: [null],
      validToDate: [null]
    });
  }

  createDataSource(): CrudDataSource<FirearmStorageLocationPLI> {
    return new FirearmStorageLocationPLIDataSource(this.firearmStorageLocationPLIService);
  }

  createServiceArguments(): any {
    return {
      firearmStorageLocationPLIId: this.firearmStorageLocationPLIIdFilter,
      firearmStorageLocationId: this.firearmStorageLocationFilter && this.firearmStorageLocationFilter.firearmStorageLocationId,
      comments: this.commentsFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      documentUploadedBy: this.documentUploadedByFilter,
      hasDocuments: this.hasDocumentsFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter,
      validFromDateLessThan: this.validFromDateLessThanFilter,
      validFromDateLessThanOrEqualTo: this.validFromDateLessThanOrEqualToFilter,
      validFromDateGreaterThan: this.validFromDateGreaterThanFilter,
      validFromDateGreaterThanOrEqualTo: this.validFromDateGreaterThanOrEqualToFilter,
      validFromDate: this.validFromDateFilter,
      validToDateLessThan: this.validToDateLessThanFilter,
      validToDateLessThanOrEqualTo: this.validToDateLessThanOrEqualToFilter,
      validToDateGreaterThan: this.validToDateGreaterThanFilter,
      validToDateGreaterThanOrEqualTo: this.validToDateGreaterThanOrEqualToFilter,
      validToDate: this.validToDateFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.firearmStorageLocationPLIIdFilter = null;
    this.firearmStorageLocationFilter = null;
    this.commentsFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.documentUploadedByFilter = null;
    this.hasDocumentsFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
    this.validFromDateLessThanFilter = null;
    this.validFromDateLessThanOrEqualToFilter = null;
    this.validFromDateGreaterThanFilter = null;
    this.validFromDateGreaterThanOrEqualToFilter = null;
    this.validFromDateFilter = null;
    this.validToDateLessThanFilter = null;
    this.validToDateLessThanOrEqualToFilter = null;
    this.validToDateGreaterThanFilter = null;
    this.validToDateGreaterThanOrEqualToFilter = null;
    this.validToDateFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.firearmStorageLocationPLIIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.firearmStorageLocationFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.documentUploadedByFilterInput);
    this.addSearchOnChangedSelectEventListener(this.hasDocumentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.validFromDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.validFromDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.validFromDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.validFromDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.validFromDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.validToDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.validToDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.validToDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.validToDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.validToDateFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      firearmStorageLocationPLIId: (value: number) => self.firearmStorageLocationPLIIdFilter = value,
      firearmStorageLocation: (value: FirearmStorageLocation) => { self.firearmStorageLocationFilter = value; this.firearmStorageLocationChanged(value, false); },
      comments: (value: string) => self.commentsFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      documentUploadedBy: (value: string) => self.documentUploadedByFilter = value,
      hasDocuments: (value: boolean) => self.hasDocumentsFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value,
      validFromDateLessThan: (value: Date) => self.validFromDateLessThanFilter = value,
      validFromDateLessThanOrEqualTo: (value: Date) => self.validFromDateLessThanOrEqualToFilter = value,
      validFromDateGreaterThan: (value: Date) => self.validFromDateGreaterThanFilter = value,
      validFromDateGreaterThanOrEqualTo: (value: Date) => self.validFromDateGreaterThanOrEqualToFilter = value,
      validFromDate: (value: Date) => self.validFromDateFilter = value,
      validToDateLessThan: (value: Date) => self.validToDateLessThanFilter = value,
      validToDateLessThanOrEqualTo: (value: Date) => self.validToDateLessThanOrEqualToFilter = value,
      validToDateGreaterThan: (value: Date) => self.validToDateGreaterThanFilter = value,
      validToDateGreaterThanOrEqualTo: (value: Date) => self.validToDateGreaterThanOrEqualToFilter = value,
      validToDate: (value: Date) => self.validToDateFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  firearmStorageLocationPLIIdChanging(value: number, unsetDependents: boolean = true) {}
  
  firearmStorageLocationPLIIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmStorageLocationLoadSelectionList() {
    this.firearmStorageLocationService.findAll().subscribe(
      data => {
        this.firearmStorageLocationSelectionList = data.items;
      }
    );
  }
  
  firearmStorageLocationDisplay(item: FirearmStorageLocation) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_STORAGE_LOCATION_TYPE.description(item);
  }
  
  firearmStorageLocationChanging(value: FirearmStorageLocation, unsetDependents: boolean = true) {}
  
  firearmStorageLocationChanged(value: FirearmStorageLocation, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  firearmStorageLocationCompare(a: any, b: any) {
    return FIREARM_STORAGE_LOCATION_METADATA.equals(a, b);
  }
  
  

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  documentUploadedByChanging(value: string, unsetDependents: boolean = true) {}
  
  documentUploadedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  hasDocumentsChanging(value: boolean, unsetDependents: boolean = true) {}
  
  hasDocumentsChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validFromDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validFromDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validFromDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validFromDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validFromDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  validFromDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validToDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validToDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validToDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validToDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  validToDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  validToDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get firearmStorageLocationPLIId() {
    return this.searchForm && this.searchForm.get('firearmStorageLocationPLIId');
  }

  get firearmStorageLocation() {
    return this.searchForm && this.searchForm.get('firearmStorageLocation');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get documentUploadedBy() {
    return this.searchForm && this.searchForm.get('documentUploadedBy');
  }

  get hasDocuments() {
    return this.searchForm && this.searchForm.get('hasDocuments');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }

  get validFromDate() {
    return this.searchForm && this.searchForm.get('validFromDate');
  }

  get validFromDateLessThan() {
    return this.searchForm && this.searchForm.get('validFromDateLessThan');
  }
  
  get validFromDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('validFromDateLessThanOrEqualTo');
  }
  
  get validFromDateGreaterThan() {
    return this.searchForm && this.searchForm.get('validFromDateGreaterThan');
  }
  
  get validFromDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('validFromDateGreaterThanOrEqualTo');
  }

  get validToDate() {
    return this.searchForm && this.searchForm.get('validToDate');
  }

  get validToDateLessThan() {
    return this.searchForm && this.searchForm.get('validToDateLessThan');
  }
  
  get validToDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('validToDateLessThanOrEqualTo');
  }
  
  get validToDateGreaterThan() {
    return this.searchForm && this.searchForm.get('validToDateGreaterThan');
  }
  
  get validToDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('validToDateGreaterThanOrEqualTo');
  }


}



